import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Row,
  Col,
  Panel,
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';

import SelectSelectize from 'components/Shared/Selectors/SelectSelectize';
import styles from './AddCreditsPanel.module.scss';

const AddCreditsPanel = ({
  handleRequestCredits,
  handleRoleSelected,
  loadingRoles = true,
  onNext,
  roles = [],
  selectedRoles = [],
  step = 1,
  user,
}) => {
  return (
    <div>
      {step === 1 && (
        <Panel bsStyle="primary" className={styles.backgroundPrimary}>
          <Row
            style={{
              margin: '10px auto',
            }}
          >
            <Col xs={12} md={6}>
              <div
                className={`${styles.mbSm} ${styles.mtMdText} text-uppercase text-center lato-bold`}
                style={{ color: 'white' }}
              >
                Hey {user.displayname}, Did you work on this?
              </div>
            </Col>
            <Col className="right" xs={12} md={6}>
              <Button
                bsStyle="success"
                style={{ width: '45%' }}
                onClick={() => onNext(2)}
              >
                Yes
              </Button>
              <Button
                className="right"
                bsStyle="info"
                style={{ width: '45%' }}
                onClick={() => onNext(4.5)}
              >
                No
              </Button>
            </Col>
          </Row>
        </Panel>
      )}
      {step === 2 && (
        <ListGroup className="text-center">
          <ListGroupItem className="text-uppercase" active>
            What was your role?
          </ListGroupItem>
          <ListGroupItem className="cf">
            <Col xs={12} sm={8}>
              <SelectSelectize
                isMulti
                hideResetButton
                options={roles.map((roleOption) => ({
                  label: roleOption.name,
                  value: roleOption.name,
                }))}
                values={selectedRoles}
                style={{ width: '100%' }}
                placeholder="Select roles..."
                renderNoResultsFound={() => (
                  <div className="no-results-found">
                    {loadingRoles ? 'loading roles...' : 'No roles found'}
                  </div>
                )}
                onValuesChange={handleRoleSelected}
                id={'AddCredits-AddCreditsPanel-roleSearch'}
              />
            </Col>
            <Col className="right" xs={12} sm={4}>
              <Button
                bsStyle="success"
                className={`${styles.mtSm} ${styles.btnBlockXs}`}
                disabled={selectedRoles.length <= 0}
                onClick={() => {
                  handleRequestCredits();
                  onNext();
                }}
              >
                Add role
              </Button>
            </Col>
          </ListGroupItem>
        </ListGroup>
      )}
    </div>
  );
};

AddCreditsPanel.propTypes = {
  handleRequestCredits: PropTypes.func,
  handleRoleSelected: PropTypes.func,
  loadingRoles: PropTypes.bool,
  onNext: PropTypes.func,
  roles: PropTypes.array,
  selectedRoles: PropTypes.array,
  step: PropTypes.number,
  user: PropTypes.object,
};

export default AddCreditsPanel;
